import {
  type DateRangePresetLabel,
  type Period,
  presetPeriod,
  resolvePeriod,
} from '@prerender/design-system/DateRangePicker';

/** The paid-user Usersnap survey asks users about this default; changing it changes what their answers refer to. */
export const DASHBOARD_DEFAULT_PRESET: DateRangePresetLabel = 'last 7 days';
export const DASHBOARD_DEFAULT_PERIOD: Period = presetPeriod(DASHBOARD_DEFAULT_PRESET);

export function getDefaultDateRange(): { dateFrom: Date; dateTo: Date } {
  const { from, to } = resolvePeriod(DASHBOARD_DEFAULT_PERIOD);
  return { dateFrom: from.toDate(), dateTo: to.toDate() };
}
